(function () {

  // Cookie helpers
  function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + '; path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return null;

    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return null;
    }
  }

  // The saved URL comes out of a cookie, which any subdomain can write, and
  // location.href will run a javascript: URI in this origin. Only ever navigate
  // to a same-origin collection path.
  function isSafeCollectionUrl(url) {
    return typeof url === 'string' &&
      /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9][a-z0-9\-_]*$/i.test(url);
  }

  function initPunchoutCollection() {
    var data = window.punchoutData || {};
    var collectionHandle = data.collectionHandle || null;
    var collectionUrl = data.collectionUrl || null;
    var collectionTitle = data.collectionTitle || null;

    // Save collection data if on a collection page
    if (collectionHandle) {
      setCookie('punchout_collection', {
        handle: collectionHandle,
        url: collectionUrl,
        title: collectionTitle
      });
    }

    // Retrieve saved collection and redirect if not on a collection page
    var savedCollection = getCookie('punchout_collection');
    if (savedCollection && isSafeCollectionUrl(savedCollection.url)) {
      if (window.location.pathname === '/' || window.location.pathname === '/account') {
        window.location.href = savedCollection.url;
      }
    }
  }

  function hidePunchoutSearch() {
    if (document.body.classList.contains('punchout')) {
      document.documentElement.classList.add('punchout');
      
      // Everything that used to be hidden here now lives in the punchout style
      // block in theme.liquid, keyed on body.punchout. Those rules apply the
      // moment TradeCentric sets the class, with no JS hop in between, and they
      // survive the section re-render that add to cart triggers.

      // No CSS equivalent: this hides only the FIRST .shopify-section on the
      // page. Giving that section a class of its own would let it move too.
      const shopifySection = document.querySelector('.shopify-section');
      if (shopifySection) shopifySection.style.display = 'none';

      const headerContainer = document.querySelector('.header');
      const policiesContainer = document.querySelector('.policies');

      // The logo the theme already rendered links to the homepage, which punchout
      // users shouldn't reach, so the link above is hidden. Re-insert an unlinked
      // copy of that same image rather than pointing at a hardcoded CDN URL.
      const storeLogo = document.querySelector('.header__heading-logo');
      if (headerContainer && storeLogo) {
        const punchoutLogo = storeLogo.cloneNode(true);
        punchoutLogo.removeAttribute('id');
        punchoutLogo.classList.add('punchout-logo');
        headerContainer.insertAdjacentElement('afterbegin', punchoutLogo);
      }

      if (policiesContainer) {
        policiesContainer.insertAdjacentHTML(
          'afterbegin',
          '<ul class="policies list-unstyled flex items-center"><li><small class="copyright__content"><a href="https://thelifeguardstore.com/pages/sizing-charts" target="_blank" class="copyright-text extra_small">Size Charts</a></small></li></ul>'
        );
      }

      // Handle collection session. Release the observer even if this throws, so a
      // bad cookie can't leave it re-firing on every class change.
      try {
        initPunchoutCollection();
      } finally {
        observer.disconnect(); // stop watching once done
      }
    }
  }

  const observer = new MutationObserver(hidePunchoutSearch);

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also run immediately in case class is already there
    hidePunchoutSearch();
  });

})();